import { useState, useEffect } from 'react';

interface ScrollProgressBarProps {
  color?: string;
  height?: number;
  showPercentage?: boolean;
}

export default function ScrollProgressBar({ 
  color = '#14b8a6', 
  height = 4,
  showPercentage = false 
}: ScrollProgressBarProps) {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      
      const totalScroll = documentHeight - windowHeight;
      const currentProgress = (scrollTop / totalScroll) * 100;
      
      setScrollProgress(Math.min(currentProgress, 100));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div 
        className="fixed top-0 left-0 right-0 z-50 bg-gray-200"
        style={{ height: `${height}px` }}
      >
        <div
          className="h-full transition-all duration-150 ease-out"
          style={{
            width: `${scrollProgress}%`,
            backgroundColor: color,
            boxShadow: `0 0 10px ${color}40`
          }}
        />
      </div>
      
      {showPercentage && scrollProgress > 5 && (
        <div 
          className="fixed top-20 right-4 z-50 bg-white border-2 border-gray-200 rounded-full px-3 py-1 shadow-lg animate-fadeIn"
        >
          <div className="flex items-center gap-2">
            <i className="ri-scroll-to-bottom-line text-teal-600"></i>
            <span className="text-sm font-semibold text-gray-900">
              {Math.round(scrollProgress)}%
            </span>
          </div>
        </div>
      )}
    </>
  );
}
